module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Calisto MT"
    }
  }, [_vm._v("My Safe Space")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "font-family": "Calisto Mt",
      "margin-left": "-10px",
      "margin-top": "20px",
      "font-weight": "normal !important"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_000#toc_id_1"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_001#toc_id_2"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_002#toc_id_3"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_003#toc_id_4"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_004#id_Toc151366858"
    }
  }, [_vm._v("My Wish")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_005#id_Toc151366859"
    }
  }, [_vm._v("The Undulating Field")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_006#id_Toc151366860"
    }
  }, [_vm._v("Your Choice")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_007#id_Toc151366861",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope and Dreams")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_008#id_Toc151366862",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridges of My Life")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_009#id_Toc151366863",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost in Space")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_010#id_Toc151366864",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cross (That Saved Me)")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_011#id_Toc151366865",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Me")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_012#id_Toc151366866",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Child")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_013#id_Toc151366867",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metamorphosis")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_014#id_Toc151366868",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Stand Accused")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_015#id_Toc151366869",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memories")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_016#id_Toc151366870",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saved (from Ruin)")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_017#id_Toc151366871",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reminisce")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_018#id_Toc151366872",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome Life")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_019#id_Toc151366873",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roles")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_020#id_Toc151366874",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wise Words")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_021#id_Toc151366875",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank You, Lord")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_022#id_Toc151366876",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_023#id_Toc151366877",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Way")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_024#id_Toc151366878",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Your Will")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_025#id_Toc151366879",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Place")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_026#id_Toc151366880",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome Dear Lord Jesus")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_027#id_Toc151366881",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tribute to Our Heroes")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_028#id_Toc151366882",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immortal")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_029#id_Toc151366883",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_030#id_Toc151366884",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When I Could Not Pray")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_031#id_Toc151366885",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_032#id_Toc151366886",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Different Views")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_033#id_Toc151366887",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_034#id_Toc151366888",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supplication")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_035#id_Toc151366889",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proclamation")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_036#id_Toc151366890",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Legacy")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0